<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >物流&订单管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/outboundIndex/outboundList' }"
          >出库管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/outboundIndex/outboundDetail' }"
          >订单详情</el-breadcrumb-item
        >
        <el-breadcrumb-item
          :to="{
            path: '/outboundIndex/outboundDistributionList',
          }"
          >配货管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>配货</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <h1>配货信息设置</h1>
      <div class="content_wrap flex-between">
        <div class="form_wrap">
          <!-- <div class="block">
            <p><span class="mark"></span>订单ID</p>
            <div class="input_box">
              <el-input
                v-model="formData.orderid"
                placeholder="请输入订单ID"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark"></span>商品ID</p>
            <div class="input_box">
              <el-input
                v-model="formData.cmid"
                placeholder="请输入商品ID"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark"></span>商品名称</p>
            <div class="input_box">
              <el-input
                v-model="formData.order_goods"
                placeholder="请输入商品名称"
              ></el-input>
            </div>
          </div> -->

          <div class="block">
            <p><span class="mark"></span>库源信息</p>
            <div class="select_box">
              <el-select
                v-model="formData.warehouse"
                placeholder="请选择库源信息"
                @change="handleWarehouseOne"
              >
                <el-option
                  v-for="item in shopWarehouseColumn"
                  :key="item.id"
                  :label="item.newMsg"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_box" v-if="false">
              <el-select
                v-model="warehouseOneId"
                placeholder="请选择仓库名称"
                @change="handleWarehouseOne"
              >
                <el-option
                  v-for="item in warehouseOneColumn"
                  :key="item.id"
                  :label="item.whname"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_box" v-if="false">
              <el-select
                v-model="warehouseTwoId"
                placeholder="请选择货架名称"
                @change="handleWarehouseTwo"
              >
                <el-option
                  v-for="item in warehouseTwoColumn"
                  :key="item.id"
                  :label="item.whname"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_box" v-if="false">
              <el-select
                v-model="warehouseThreeId"
                placeholder="请选择层名称"
                @change="handleWarehouseThree"
              >
                <el-option
                  v-for="item in warehouseThreeColumn"
                  :key="item.id"
                  :label="item.whname"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_box" v-if="false">
              <el-select v-model="warehouseFourId" placeholder="请选择货位名称">
                <el-option
                  v-for="item in warehouseFourColumn"
                  :key="item.id"
                  :label="item.whname"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <!-- <div class="block">
            <p><span class="mark"></span>cmnum</p>
            <div class="input_box">
              <el-input
                v-model="formData.cmnum"
                placeholder="请输入cmnum"
              ></el-input>
            </div>
          </div> -->
        </div>
        <div class="tip_wrap">
          <div class="item">
            <h1>商品信息：</h1>
            <div class="content">
              <p>商品名称：{{ orderShopItem.cmname }}</p>
              <!-- <p>商品ID：{{ orderShopItem.cmid }}</p> -->
              <p>SKU：{{ orderShopItem.sku }}</p>
              <p>{{orderShopItem.attr}}</p>
              <!-- <div
                v-for="(label, labelIndex) in orderShopItem.attr"
                :key="labelIndex"
              >
                <p>
                  <span>{{ label | formatAttr }}</span>
                </p>
              </div> -->
              <p>商品所属企业：{{ orderShopItem.qyguidstr }}</p>
              <p>配货所需数量：{{ orderShopItem.cmnum }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div
        class="btn"
        :class="orderShopItem.warehouse != '' ? 'disable' : ''"
        @click="query"
      >
        确认
      </div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <!--  主要内容 end -->
  </div>
</template>

<script>
import { getWearhouseList, encryptstringview } from "../../api/api";
import {
  getLogisticsDisDetail,
  addLogisticsDis,
  editLogisticsDis,
  getShopWarehouse,
} from "../../api/shop";
export default {
  name: "outboundDistribution",
  data() {
    return {
      columns: [],
      loading: false,
      formData: {
        id: "",
        warehouse: "", // 仓库id
      },
      wsid: "",
      warehouseName: "",
      qyid: "",
      shopWarehouseColumn: [],

      warehouseOneColumn: [],
      warehouseOneId: "",
      warehouseOneName: "",

      warehouseTwoColumn: [],
      warehouseTwoId: "",
      warehouseTwoName: "",

      warehouseThreeColumn: [],
      warehouseThreeId: "",
      warehouseThreeName: "",

      warehouseFourColumn: [],
      warehouseFourId: "",
      warehouseFourName: "",

      orderShopItem: "", // 配货详情
    };
  },
  filters: {
    formatAttr(date) {
      if (date.indexOf("；") != -1) {
        let splitArr = date.split("；");
        let str1 = "属性标签：" + splitArr[0];
        let str2 = "属性标签值：" + splitArr[1];
        return str1 + "；" + str2;
      } else {
        let str = "属性标签：" + date;
        return str;
      }
      // let splitArr = date.indexOf('；') != -1 ? date.split('；') : date
    },
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.qyid = USERINFO.qy.id ? USERINFO.qy.id : "";

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, wsid } = JSON.parse(res.jsondata);
        this.wsid = wsid;
        if (id != 0) {
          this.formData.id = id;
          this.getLogisticsDisDetail(id);
        } else {
          this.formData.id = "";
        }
      } else {
        this.$router.back();
      }
    },

    // 仓库配货详情
    getLogisticsDisDetail(id) {
      this.loading = true;
      getLogisticsDisDetail({ id }).then((res) => {
        res.attr = res.attr != "" && res.attr ? JSON.parse(res.attr) : [];
        this.orderShopItem = res;
        this.formData.id = res.id;
        this.formData.warehouse = res.warehouse ? parseInt(res.warehouse) : "";
        this.getShopWarehouse(res.cmid);
        this.loading = false;
      });
    },

    // 获取仓库列表
    getWearhouseList() {
      console.log(this.$store.state.OPENID);
      let params = {
        openid: this.$store.state.OPENID,
        qyid: this.qyid,
      };
      getWearhouseList(params).then((res) => {
        this.warehouseOneColumn = res;
      });
    },
    // 选择仓库
    handleWarehouseOne(e) {
      let { warehouseOneColumn } = this;
      warehouseOneColumn.forEach((v) => {
        if (v.id == e) {
          this.warehouseTwoColumn = v.childs2;
          this.warehouseThreeColumn = [];
          this.warehouseFourColumn = [];
          this.warehouseTwoId = "";
          this.warehouseTwoName = "";
          this.warehouseThreeId = "";
          this.warehouseThreeName = "";
          this.warehouseFourId = "";
          this.warehouseFourName = "";
        }
      });
    },
    // 选择货架
    handleWarehouseTwo(e) {
      let { warehouseTwoColumn } = this;
      warehouseTwoColumn.forEach((v) => {
        if (v.id == e) {
          this.warehouseThreeColumn = v.childs3;
          this.warehouseFourColumn = [];
          this.warehouseThreeId = "";
          this.warehouseThreeName = "";
          this.warehouseFourId = "";
          this.warehouseFourName = "";
        }
      });
    },
    // 选择层
    handleWarehouseThree(e) {
      let { warehouseThreeColumn } = this;
      warehouseThreeColumn.forEach((v) => {
        if (v.id == e) {
          this.warehouseFourColumn = v.childs4;
          this.warehouseFourId = "";
          this.warehouseFourName = "";
        }
      });
    },

    // 获取某个商品下的库存信息
    getShopWarehouse(cmid) {
      let { orderShopItem } = this;
      // 商品属性标签进行分解
      // const modifiedArray = orderShopItem.attr.map((item) =>
      //   item.replace("；", ";")
      // );
      // let attrNew = orderShopItem.attr.map((item) => {
      //   const [attrIdStr, attrValueStr] = item.split("；");
      //   return {
      //     ams_shop_commodity_attridstr: attrIdStr,
      //     ams_shop_commodity_attr_valuestr: attrValueStr,
      //   };
      // });
      getShopWarehouse({ cmid }).then((res) => {
        res.forEach((v) => {
          v.newMsg =
            v.attr +
            " | " +
            "库源数量：" +
            v.num +
            " | " +
            "仓库：" +
            v.whid1str +
            " | " +
            "货架：" +
            v.whid2str +
            " | " +
            "层：" +
            v.whid3str +
            " | " +
            "货位：" +
            v.whid4str;
        });
        // 过滤当前商品相同的属性
        const filterArr = res.filter(
          (obj) => obj.attr === JSON.stringify(orderShopItem.attr)
        );
        this.shopWarehouseColumn = filterArr;
      });
    },

    // 保存
    query() {
      if (this.orderShopItem.warehouse != "") {
        return;
      }
      let { formData } = this;
      if (formData.warehouse == "") {
        this.$message.warning("请选择货源信息");
        return;
      }
      if (formData.id == "") {
        this.addLogisticsDis();
      } else {
        this.editLogisticsDis();
      }
    },
    // 添加数据
    addLogisticsDis() {
      let { formData } = this;
      this.loading = true;
      addLogisticsDis(formData).then((res) => {
        let data = res;
        if (data.result) {
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(data.message || "服务器报错，请稍后～");
        }
      });
    },

    // 修改数据
    editLogisticsDis() {
      let { formData } = this;
      this.loading = true;
      editLogisticsDis(formData).then((res) => {
        let data = res;
        if (data.result) {
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(data.message || "服务器报错，请稍后～");
        }
      });
    },
    // 返回
    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      .form_wrap {
        margin-right: 100px;
      }
      .tip_wrap {
        flex: 1;
        .item {
          margin-bottom: 30px;
          color: #6e6e6e;
          h1 {
            margin-bottom: 8px;
            font-size: 18px;
          }
          p {
            font-size: 16px;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
  .btn {
    &.disable {
      background: #a6a6a6;
    }
  }
}
</style>